import api from '@/api/jobFit'

const state = {

}

const actions = {
  createGenerateJobFitConditionTask (context, jobId) {
    return api.createGenerateJobFitConditionTask(jobId)
  },
  getJobFitConditionTask (context, { jobId, taskId }) {
    return api.getJobFitConditionTask(jobId, taskId)
  },
  getJobFitCondition (context, jobId) {
    return api.getJobFitCondition(jobId)
  },
  saveJobFitCondition (context, { jobId, condition }) {
    return api.saveJobFitCondition(jobId, condition)
  },
  createTestJobFitConditionTask (context, { jobId, testInfo }) {
    return api.createTestJobFitConditionTask(jobId, testInfo)
  },
  getTestJobFitConditionTask (context, { jobId, taskId }) {
    return api.getTestJobFitConditionTask(jobId, taskId)
  },
  getRefreshJobFitTask (context, params) {
    return api.getRefreshJobFitTask(params)
  },
  createRefreshJobFitTask (context, jobId) {
    return api.createRefreshJobFitTask(jobId)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
